exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    overflow: auto;\r\n}\r\n\r\na:link {\r\n    color: black;\r\n    text-decoration: none;\r\n}\r\n\r\na:visited {\r\n    color: black;\r\n    text-decoration: none;\r\n}\r\n\r\na:hover {\r\n    color: black;\r\n    text-decoration: none;\r\n}\r\n\r\na:active {\r\n    color: black;\r\n    text-decoration: none;\r\n}\r\n\r\n@supports (-ms-ime-align: auto) {\r\n    :host {\r\n        flex: 1 1 auto;\r\n        height: 1px;\r\n    }\r\n}\r\n\r\n.kendo-grid {\r\n    flex: 1 1 auto;\r\n    overflow: auto;\r\n}\r\n\r\n.grid-image {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    width: 100%;\r\n}\r\n\r\n.grid-editable-input {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    width: 100%;\r\n}\r\n\r\n.whole-cell {\r\n    display: block;\r\n    padding: 8px 12px;\r\n}\r\n\r\n.whole-cell-image {\r\n    display: block;\r\n    padding: 36px 12px;\r\n}\r\n\r\n.whole-cell-image-small {\r\n    display: block;\r\n    padding: 21px 12px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/dynamic-grids/dynamic-grid.component.css
// module id = 2271
// module chunks = 1